export { default } from './ImagePlusTextBlock';
